import View from "../../../Nav/Js/views/PubliParallax";
import components from "./components.js";
components.define("js-publiParallax", View);